import type { Money, MoneyResponse } from "~/services/types/Money"

export function mapMoneyResponse(moneyResponse: MoneyResponse): Money {
  return {
    amount: moneyResponse.amount,
    currency: moneyResponse.currency,
  }
}
